import React from 'react'
import styled from 'styled-components'

import { Button } from '@toptal/picasso'

import { ButtonContent } from './ButtonContent'
import { IExtraOption } from '../../utils'

const ButtonGroupTitle = styled.span`
  display: inline-block;
  margin-right: 1rem;
  min-width: 4.5rem;
`

interface IButtonGroupsProps {
  title: string
  buttons: IExtraOption[]
  activeKind: string
  onChange(kind: string, value: string): void
}

const ButtonGroup: React.FunctionComponent<IButtonGroupsProps> = props => {
  const { title, buttons, activeKind, onChange } = props

  return (
    <Button.Group>
      <ButtonGroupTitle>{title}:</ButtonGroupTitle>
      {buttons.map(button => {
        const { kind, value, title: buttonTitle } = button
        const active = activeKind === kind
        return (
          <Button
            active={active}
            onClick={() => onChange(kind, value)}
            key={kind}
          >
            <ButtonContent
              active={active}
              onChange={onChange}
              kind={kind}
              value={value}
              title={buttonTitle}
            />
          </Button>
        )
      })}
    </Button.Group>
  )
}

export default ButtonGroup
